import { html } from 'lit';
import type { TemplateResult } from 'lit';

// Shown only when the audio fails to load (wrong stems-url, 404, offline).
export function renderErrorPanel(onRetry: () => void): TemplateResult {
  return html`
    <div class="error-panel" role="alert">
      <p>Couldn't load the demo.</p>
      <div class="error-actions">
        <button type="button" class="island-btn text-btn outlined" @click=${onRetry}>Retry</button>
      </div>
    </div>
  `;
}
